<!-- BaseCheckBoxBudget.vue -->
<template>
  <div
    class="budget-option flex flex-row sm:flex-row sm:items-center sm:justify-between justify-between items-center gap-4 border border-gray-300 rounded-lg p-3 w-full sm:w-1/3 cursor-pointer hover:bg-gray-50 transition"
    @click="toggleSelection">
    <div>
      <p class="text-gray-500 text-sm">{{ label }}</p>
      <p class="text-black font-semibold text-sm break-words">{{ priceRange }}</p>
    </div>
    <input id="checkbox-{{ label }}" type="checkbox" class="form-checkbox h-5 w-5 text-blue-600"
      :checked="modelValue === budgetType" readonly />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BaseCheckBoxBudget',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true
    },
    priceRange: {
      type: String,
      required: true
    },
    budgetType: {
      type: String,
      required: true
    },
    value: {
      type: String, // Nilai checkbox ini (contoh: 'economy', 'popular', 'luxury')
      required: true,
    },
  },
  computed: {
    ...mapGetters('properties', ['selectedBudgets']),
    isSelected() {
      return this.selectedBudgets[this.budgetType];
    }
  },
  methods: {
    ...mapActions('properties', ['toggleBudgetSelection']),
    toggleSelection() {
      // Jika sudah dipilih dan klik lagi, uncheck (null)
      if (this.modelValue === this.budgetType) {
        this.$emit("update:modelValue", null);
      } else {
        // Jika belum dipilih, set value ke budgetType (economy/poular/luxury)
        this.$emit("update:modelValue", this.budgetType);
      }
    },
  }
};
</script>

<style scoped>
.budget-option {
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}

.budget-option:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>